var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowAngle = function SvgArrowAngle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_angle_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".arrow_angle_svg__st0{fill:none;stroke:#666;stroke-linecap:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow_angle_svg__st0",
    d: "M20.7 27.7v-7.4h7.4M30.2 29.9 21 20.7"
  })));
};
export default SvgArrowAngle;